/**
 * Language switcher controller
 * Handles language selection from footer dropdown
 * Loaded globally via layout.php
 */

import { ApiClient } from '../lib/ApiClient';

const select = document.getElementById('language-switcher') as HTMLSelectElement | null;

function setCookie(name: string, value: string, days: number): void {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

async function changeLanguage(locale: string): Promise<void> {
    // Always set cookie (works for both anonymous and authenticated)
    setCookie('locale', locale, 365);

    // For authenticated users, also save to database
    // Check data-authenticated attribute set by PHP
    if (select?.hasAttribute('data-authenticated')) {
        try {
            const apiClient = new ApiClient();
            await apiClient.authenticatedPut('/api/user/language', { language: locale });
        } catch {
            // Cookie is set, so language will still work on reload
            console.warn('Failed to save language preference to server');
        }
    }

    // Reload to apply new language
    window.location.reload();
}

if (select) {
    select.addEventListener('change', () => {
        changeLanguage(select.value);
    });
}
